import * as S from "./style";
//Components
import ActionButton from "../../Button/ActionButton";
import ActionButtonResponsy from "../../Button/ActionButtonResponsy";

import InputSearch from "../../FieldSearch";
import PopMenu from "../../PopMenu";

import CreateAgreements from "../../Modals/Agreements/Create";
import LayoutCustomer from "../../Modals/Customer/LayoutCreate";

import CreateBrainds from "../../Modals/Brainds/Create";
import Create from "../../Modals/Frame/Create";
import CreateMaterial from "../../Modals/Material/Create";
import CreateSupplier from "../../Modals/Supplier/Create";

import CreateAntiGlare from "../../Modals/AntiGlare/Create";
import CreateDiameter from "../../Modals/Diameter/Create";
import CreateHeight from "../../Modals/Height/Create";
import CreateIndice from "../../Modals/Indice/Create";
import CreateLens from "../../Modals/Lens/Create";
import CreateSurfacing from "../../Modals/Surfacing/Create";

import CreateLaboratory from "../../Modals/Laboratory/Create";
import CreateSensitivity from "../../Modals/Sensitivity/Create";
import CreateTypeLens from "../../Modals/TypeLens/Create";

import CreateCategory from "../../Modals/Expense/Category/Create";
import CreateExpenses from "../../Modals/Expense/Create";

import CreateRetr from "../../Modals/Retroactive/Create";

import Toast from "../../Toast";
//Hooks
import { useMultipleModal } from "../../../hooks/useMultipleModal";
//Icons
import { CaretDown, Export } from "@phosphor-icons/react";
import { ITitle } from "Interfaces/ITitle";
import { useState } from "react";

export default function TitleMenu({
  title,
  subtitle,
  placeholderSearch,
  listPopMenu,
  listPopButton,
  fetchData,
  filterSearch,
  exportButton,
  visibleButton = true,
  visibleButtonExport = true,
}: ITitle) {
  const { isOpenModal, toggleModalVisibility, assignRef } = useMultipleModal();
  const [toastData, setToastData] = useState({
    status: 200,
    message: "",
  });

  const handleInputChange = (inputSearch: string) => {
    filterSearch(inputSearch);
  };

  return (
    <S.Container>
      <S.Title>
        <S.H4>{title}</S.H4>
        <S.H6>{subtitle}</S.H6>
      </S.Title>

      <S.ContentSearch>
        {/* // Button Pesquisar */}
        <InputSearch name={placeholderSearch} onSearch={handleInputChange} />

        <S.ContentButton>
          {/* // Button Export */}
          {
            visibleButtonExport &&
            <ActionButtonResponsy
              name="Exportar"
              Icon={<Export size={18} weight="bold" />}
              onClick={exportButton}
            />
          }

          {/* // Button Cadastro */}
          {visibleButton && (
            <S.ContentPopButton>
              <ActionButton
                name="Novo Cadastro"
                Icon={<CaretDown size={16} weight="fill" />}
                onClick={() => toggleModalVisibility("menu")}
              />
              {isOpenModal("menu") && (
                <div ref={(ref) => assignRef("menu", ref)}>
                  <PopMenu
                    listName={listPopMenu}
                    onClickHandlers={listPopButton?.map((val) => {
                      return () => toggleModalVisibility(val);
                    })}
                  />
                </div>
              )}
            </S.ContentPopButton>
          )}
        </S.ContentButton>
      </S.ContentSearch>

      <LayoutCustomer
        isOpenModal={isOpenModal("customer")}
        setIsOpenModal={() => toggleModalVisibility("customer")}
        refreshData={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      {/* <CreateCustomer
        isOpenModal={isOpenModal("customer")}
        setModalClose={() => toggleModalVisibility("customer")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      /> */}
      <Create
        isOpenModal={isOpenModal("create")}
        setModalClose={() => toggleModalVisibility("create")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateSupplier
        isOpenModal={isOpenModal("supplier")}
        setModalClose={() => toggleModalVisibility("supplier")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateBrainds
        isOpenModal={isOpenModal("brainds")}
        setModalClose={() => toggleModalVisibility("brainds")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateMaterial
        isOpenModal={isOpenModal("material")}
        setModalClose={() => toggleModalVisibility("material")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateLens
        isOpenModal={isOpenModal("lens")}
        setModalClose={() => toggleModalVisibility("lens")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateAntiGlare
        isOpenModal={isOpenModal("anti-glare")}
        setModalClose={() => toggleModalVisibility("anti-glare")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateTypeLens
        isOpenModal={isOpenModal("type-lens")}
        setModalClose={() => toggleModalVisibility("type-lens")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateSensitivity
        isOpenModal={isOpenModal("sensitivity")}
        setModalClose={() => toggleModalVisibility("sensitivity")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateLaboratory
        isOpenModal={isOpenModal("laboratory")}
        setModalClose={() => toggleModalVisibility("laboratory")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateAgreements
        isOpenModal={isOpenModal("agreement")}
        setModalClose={() => toggleModalVisibility("agreement")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateExpenses
        isOpenModal={isOpenModal("expense")}
        setModalClose={() => toggleModalVisibility("expense")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateCategory
        isOpenModal={isOpenModal("category-expense")}
        setModalClose={() => toggleModalVisibility("category-expense")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateSurfacing
        isOpenModal={isOpenModal("surfacing")}
        setModalClose={() => toggleModalVisibility("surfacing")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateDiameter
        isOpenModal={isOpenModal("diameter")}
        setModalClose={() => toggleModalVisibility("diameter")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateIndice
        isOpenModal={isOpenModal("index")}
        setModalClose={() => toggleModalVisibility("index")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateHeight
        isOpenModal={isOpenModal("height")}
        setModalClose={() => toggleModalVisibility("height")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <CreateRetr
        isOpenModal={isOpenModal("retroactive-sale")}
        setModalClose={() => toggleModalVisibility("retroactive-sale")}
        refreshFrames={fetchData}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <Toast
        openToast={isOpenModal('open-toast')}
        closeToast={() => toggleModalVisibility('open-toast')}
        message={toastData.message}
        status={toastData.status}
      />
    </S.Container>
  );
}
